export default "__VITE_PUBLIC_ASSET__c47f9798__"